import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs/index';
import { filter, map, tap } from 'rxjs/operators';
import { Person } from '../../core/model/central/person.model';
import { Message } from '../../message-list/message.model';
import { PersonMessageService } from '../../message-list/person-message.service';
import { PatientsSelectors } from './state/patients.selectors';

// -----------------------------

// The flow is that frontend requests entity data (based on QueryParams - e.g. personId and initial limit and offset)
// backend responds with initial data including queryFilter according to what the backend provided data
// frontend (NgRx Data) updates queryFilter state
// frontend may use current queryFilter (if any) and append/modify for future requests to backend.
// The data always flows one direction. Frontend should NOT update queryFilter state in any other way than
// with state from backend.
// Also, frontend should never change entity data - except updating with new data from backend (using reducers)
@Component({
    selector: 'patient-messages',
    templateUrl: './patient-messages.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientMessagesComponent implements OnInit, OnDestroy {

    // This is a Container component - since this is a "route-component" we can't use inputs and thus this has to get rely on state

    selectedPatient$: Observable<Person>;
    selectedPatient: Person;

    personMessages$: Observable<Array<Message>>;
    loading$: Observable<boolean>;
    queryFilter$: Observable<any>;
    refreshing$: Observable<boolean>;

    constructor(private patientsSelectors: PatientsSelectors,
                private messageService: PersonMessageService
    ) {
        this.selectedPatient$ = this.patientsSelectors.selectSelectedPatient();
        this.queryFilter$ = this.messageService.queryFilter$;
        this.personMessages$ = this.messageService.entities$
        .pipe(filter(messages => messages !== undefined));

        this.loading$ = combineLatest([this.messageService.loading$, this.messageService.refreshing$])
            .pipe(
                map(([loading, refreshing]) => (loading || refreshing))
            );
    }

    ngOnInit(): void {
        // TODO: Consider if we should always dispatch action - and let side-effect check state and only load if relevant?
        this.selectedPatient$
            .pipe(
                filter(patient => patient !== undefined),
                tap(patient => {
                    // TODO: Can we move this to an effect? it should only apply when Messages tab is opened/reopened?
                    this.initGettingMessages(patient);
                })
            )
            .subscribe(patient => { // TODO: Subscribe in view
                console.log(patient);
            });
    }

    ngOnDestroy(): void {
        this.messageService.unsubscribeWebSocketJob();
    }

    // TODO: When switching person we should clear the entity and queryFilter and perhaps reject any pushes from backend for different personId

    initGettingMessages(patient: Person): void {
        if (this.selectedPatient === undefined) {
            this.selectedPatient = patient;
            this.messageService.subscribeWebSocketJob({personId: `${patient.personId}`});
            // this.messageService.getWithQuery({personId: `${patient.personId}`});
        } else {
            // Reset if different person selected
            this.messageService.resetWebSocketJob({personId: `${patient.personId}`});
        }
    }

    getMoreMessagesOnScroll(patient: Person, queryFilter: any): void {
        this.messageService.refreshWebSocketJob({
            personId: `${patient.personId}`,
            offset: `${queryFilter.totalLoaded}`});
    }
}
